module.exports = __webpack_public_path__ + "img/like_inactive.d371ffee.png";